import axios from '@/util/request'

// 获取最近的五条记录
// export function getRecentRecords () {
//   let url = '/api/v1/record/get_recent_records/'
//   return axios.get(url)
// }

export function getRecords (data) {
  let url = '/api/v1/record/get_records'
  return axios.post(url, data)
}

export function exportRecords (param) {
  let url = '/api/v1/record/export_records?' + Object.keys(param).filter(k => param[k]).map(k => k + '=' + param[k]).join('&')
  location.href = url
}

// 更新记录（审核记录）
export function updateRecord (data) {
  let url = '/api/v1/record/update_record'
  return axios.post(url, data)
}

// 静态地图地图上显示所有红外相机机位和预警设备机位
// export function getFrequenPointsOnMap () {
//   let url = '/api/v1/record/get_frequent_points_on_map/'
//   return axios.get(url)
// }

// 增加柱状图，横轴为月份，纵轴为当月绿孔雀报警触发数量。
// export function getFrequenceEveryMonth () {
//   let url = '/api/v1/record/get_frequence_every_month/'
//   return axios.get(url)
// }

// 下载
// export function getFrequenceEveryMonth() {
//     let url = '/api/v1/record/get_records/';
//     return axios.get(url);
// }
//
// /api/v1/record/get_animal_type
export function getAnimalType () {
  let url = '/api/v1/record/get_animal_type/'
  return axios.post(url)
}

// /api/v1/record/get_records_for_download
export function downloadRecords (data) {
  const config = {
    responseType: 'blob'
  }
  let url = '/api/v1/record/get_records_for_download/'
  return axios.post(url, data, config)
}

// 简单审核页面根据id获取图片
export function getImgLinkById (data) {
  let url = '/api/v1/record/get_record_img_url_by_id/'
  return axios.post(url, data)
}

// 提交审核
export function checkRecord (data) {
  let url = '/api/v1/record/simple_check_record/'
  return axios.post(url, data)
}
